import { Content, Portal, Root, Trigger } from "@radix-ui/react-dialog"

import type { DialogProps } from "./Dialog"
import styles from "./FullscreenDialog.module.css"

/* Private component. */

type Props = { onEscapeKeyDown: (evt: KeyboardEvent) => void } & Pick<
  DialogProps,
  "open" | "onOpenChange" | "trigger" | "children" | "onAnimationEnd"
>

export function FullscreenDialog(props: Props) {
  const { trigger, children, onAnimationEnd, onEscapeKeyDown, ...otherProps } =
    props

  return (
    <Root {...otherProps}>
      {trigger && <Trigger asChild>{trigger}</Trigger>}

      <Portal>
        <Content
          className={styles.container}
          onAnimationEnd={onAnimationEnd}
          onEscapeKeyDown={onEscapeKeyDown}
        >
          {children}
        </Content>
      </Portal>
    </Root>
  )
}
